<template>
  <div class="page" v-loading="loading">
    <box fill>
			<plabel text="Direct Material">
				<el-button class="btn-t-edit" @click="printBtn()" v-authority="'BACK_MENU7_M15_B1'">打印</el-button>
				<el-button class="btn-t-edit" @click="getMainData()">刷新</el-button>
			</plabel>
      <!-- 展示 -->
			<div id="pdfDown" class="pdfDown">
      <div style="padding: 10px 0px;border-bottom: 5px dashed #8bc34a;" v-for="(item,index) in mainData" :key="index">
        <!-- 第一行表格 -->
        <el-row>
          <el-col :span="8">
            <div class="left_div">
							<el-table :data="item.leftTableData" style="width: 100%;border: 1px solid;" border>
								<el-table-column align="center" prop="factory" label="Factory"></el-table-column>
								<el-table-column align="center" prop="emptyBin" label="Empty Bin"></el-table-column>
								<el-table-column align="center" prop="totalBin" label="Total Bin"></el-table-column>
								<el-table-column align="center" prop="utilization" label="Utilization"></el-table-column>
							</el-table>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="right_div">
							<el-table :data="item.rightTableData" style="width: 100%;border: 1px solid;" border>
								<el-table-column align="center" prop="name" label="Inventory aging" width="150px"></el-table-column>
								<el-table-column align="center" prop="sum" label="Sum"></el-table-column>
								<el-table-column align="center" prop="3m" label="＜3M"></el-table-column>
								<el-table-column align="center" prop="48m" label="4-8M"></el-table-column>
								<el-table-column align="center" prop="812m" label="8-12M"></el-table-column>
								<el-table-column align="center" prop="12y" label="1-2Y"></el-table-column>
								<el-table-column align="center" prop="23y" label="2-3Y"></el-table-column>
								<el-table-column align="center" prop="35y" label="3-5Y"></el-table-column>
							</el-table>
            </div>
          </el-col>
        </el-row>
        <!-- 第二行图表 -->
        <el-row>
          <el-col :span="8">
						<div class="left_div">
							<div class="echarts-box" :ref="'echartsPie-' + index"></div>
						</div> 
					</el-col>
          <el-col :span="16">
						<div class="right_div">
							<div class="echarts-box" :ref="'echartsLine-' + index"></div>
						</div>
					</el-col>
        </el-row>
      </div>
			</div>
    </box>
  </div>
</template>
<script>
import htmlToPdf from "@/libs/htmlToPdf";
import * as echarts from "echarts"; // 导图全局 echarts
export default {
  name: "ReportDirectMaterial",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
			loading: true, //加载中
      
			//打印
      print: false,
    };
  },
  watch: {},
	mounted() {},
  methods: {
		printBtn(){
			this.$nextTick(() => {this.getPdf(document.querySelector("#pdfDown"),"Direct Material报表");})
		},
    //获取数据
    getMainData() {
			this.loading = true;
      this.$http
        .request({
          url: "/api/reportForms/DirectMaterialReport",
          method: "GET",
          params: {},
        })
        .then((resp) => {
					this.loading = false;
          if (resp.status == 100) {
            this.mainData = resp.data || [];
						this.mainData.forEach((iten, index) => {
							this.setPieChart(iten.dataPie, index);
							this.setLineChart(iten.dataLine,iten.dataLineTitle, index);
						});
          } else {
						this.loading = false;
						this.$message({
							message: resp.message,
							type: "error",
						});
					}
        })
        .catch((error) => {
          this.$message({
						message: "操作失败",
						type: "error",
          });
        });
    },
		
    setPieChart(data,index) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs['echartsPie-' + index][0]);
    		var optionChart = {
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b} : {c} ({d}%)",
					},
					legend: {
						orient: "horizontal",
						type: "scroll",
						bottom: "1%"
					},
					series: [{
						name: "Direct Material",
						type: "pie",
						radius: "50%",
						// center: ["40%", "50%"],
						data: data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
					}],
				}
				myChart.setOption(optionChart);
      });
		},
		setLineChart(data,title,index) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs['echartsLine-'+index][0]);
    		var optionChart = {
					title: {
						text: 'Direct Material Value & Quantity',
						left: "center",
						top: 10
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['Quantity', 'Value'],
						orient: "horizontal",
						type: "scroll",
						bottom: "1"
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: "30",
						containLabel: true
					},
					toolbox: {
						// feature: {
						// 	saveAsImage: {}
						// }
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: title
					},
					yAxis: {
						type: 'value'
					},
					series: data
				};
				myChart.setOption(optionChart);
			});
		},
  },
  activated() {
    /* 获取首页的数据 */
		this.getMainData();
  },
};
</script>

<style scoped>
.left_div {
  margin: 0px 10px;
  text-align: center;
}
.right_div {
  margin: 0px 10px;
  text-align: center;
}
.echarts-box {
	min-height: 300px;
	border-bottom: 1px solid;
	border-left: 1px solid;
	border-right: 1px solid;
}
</style>